import React, { useState } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SearchWorkups = ({ onSearchTextChange, searchText }) => {
  const handleSearchChange = (e) => {
    const {
      target: { value },
    } = e;

    onSearchTextChange(value);
  };

  return (
    <div>
      <TextField
        className="search"
        placeholder="Search Workup "
        type="text"
        variant="outlined"
        fullWidth
        size="small"
        onChange={handleSearchChange}
        value={searchText}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),

          endAdornment: searchText && (
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => onSearchTextChange("")}
            >
              <CloseIcon />
            </IconButton>
          ),
        }}
      />
    </div>
  );
};

export default SearchWorkups;